import { ReactElement, useState } from "react";
import { Button } from "src/components/ui/button";
import Download from "src/assets/icons-redesign/download.svg?react";
import { Loader2 } from "lucide-react";
import { Skeleton } from "src/components/ui/skeleton";
import { apiUrl } from "src/constants/config";
import InvisiblyApiService from "src/services/api/invisibly-api.service";
import { createShare } from "src/services/surveys/surveys.helpers";
import ReduxService from 'src/redux/redux.service';
import { RootState } from "src/redux/redux-store";

type ResultsSidebarHeaderDownloadProps =
  | {
    variant: "download",
    isShare: boolean,
    surveyId: string,
    title: string,
  }
  | { variant: "cannotDownload" }
  | { variant: "skeleton" };

const ResultsSidebarHeaderDownload = (props: ResultsSidebarHeaderDownloadProps): ReactElement | null => {
  const [isDownloading, setIsDownloading] = useState(false);

  const getUrl = (url: string) => {
    const state = ReduxService.Store.getState() as RootState;
    const isClientActive = state.userState.activeClient;
    return isClientActive ? url.replace('b2b', 'client') : url;
  };

  const { variant } = props;

  if (variant === "skeleton") {
    return <Skeleton className="w-32 h-12" />;
  }

  if (variant === "cannotDownload") {
    return null;
  }

  const handleDownload = async () => {
    const state = ReduxService.Store.getState() as RootState;
    const isClientActive = state.userState.activeClient;
    const { isShare, surveyId, title } = props;

    let url = createShare(getUrl(`${apiUrl}/b2b/survey/${surveyId}/csv`), isShare, 'b2b');
    const fileName = title.trim().toLowerCase().split(' ').join('_') + '.csv';

    if (isClientActive) {
      url = url + '?client_id=' + state.userState.activeClient?.ext_client_id;
    }

    setIsDownloading(true);
    try {
      await InvisiblyApiService.invokeDownloadRequest(url, fileName);
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <Button
      onClick={handleDownload}
      disabled={isDownloading}
      className=""
      size="med"
      title="Download survey data as a csv"
    >
      {isDownloading ? (
        <Loader2 className="size-10 animate-spin" />
      ) : (
        <Download className="size-10" />
      )}
    </Button>
  );
};

export default ResultsSidebarHeaderDownload;
export type { ResultsSidebarHeaderDownloadProps };
